import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import '../../styles/PartCard.css';
import { AssistancePartListDTO } from '../../models/AssistanceParts/AssistancePartListDTO';
import ButtonComponent from '../ButtonComponent';
import CheckboxComponent from '../CheckboxComponent';

export type UsedPartCardProps = {
    part: AssistancePartListDTO;
    onRemove: () => void;
    onUpdateBillable: (billable: boolean) => void;
    onBillableChange: (billable: boolean) => void;
    showBillable: boolean;
    showUpdateButton: boolean;
    showRemoveButton: boolean;
    isLocked: boolean;
};

export const UsedPartCard: React.FC<UsedPartCardProps> = ({
    part,
    onRemove,
    onUpdateBillable,
    onBillableChange,
    showBillable,
    showUpdateButton,
    showRemoveButton,
    isLocked,
}) => {
    const intl = useIntl();
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="part-card">
            <div className="part-card__icon-container">
                <div className="part-card__quantity">
                    QTD: {part.quantity}
                </div>
            </div>
            <div className="part-card__content">
                <div className="part-card__code" style={{ marginBottom: '8px' }}>
                    {part.erpId}
                </div>
                <div className="part-card__name" style={{ marginBottom: '12px' }}>
                    {part.name}
                </div>

                {showBillable && (
                    <div style={{ marginBottom: '12px' }}>
                        <CheckboxComponent
                            checked={part.billable}
                            disabled={isLocked}
                            onChange={(checked) => onBillableChange(checked)}
                            label={intl.formatMessage({ id: "Screens.Assistances.Parts.Table.Billable" })}
                        />
                    </div>
                )}

                {part.requestPartDescription && (
                    <>
                        <button
                            className="part-card__select-button"
                            onClick={() => setIsExpanded(!isExpanded)}
                            style={{ marginBottom: '8px' }}
                        >
                            {isExpanded
                                ? intl.formatMessage({ id: "ExecutionsTableComponent.Close" })
                                : intl.formatMessage({ id: "ExecutionsTableComponent.Open" })
                            }
                            {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                        </button>
                        {isExpanded && (
                            <div style={{
                                padding: '12px',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '8px',
                                marginBottom: '12px',
                                fontSize: '0.9rem',
                                lineHeight: '1.5'
                            }}>
                                <strong><FormattedMessage id="Screens.Assistances.Parts.Table.PartDescription" />:</strong>
                                <div style={{ marginTop: '4px' }}>{part.requestPartDescription}</div>
                            </div>
                        )}
                    </>
                )}

                <div className="part-card__action" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {showUpdateButton && (
                        <ButtonComponent
                            text={intl.formatMessage({ id: "PartsUsedTableComponent.UpdateBillable" })}
                            onClick={() => onUpdateBillable(part.billable)}
                            style={{ width: '100%' }}
                        />
                    )}
                    {showRemoveButton && (
                        <ButtonComponent
                            text={intl.formatMessage({ id: "PartsUsedTableComponent.Remove" })}
                            onClick={onRemove}
                            style={{ width: '100%' }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
